import script from "./RingScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./RingScreen.vue?vue&type=script&setup=true&lang=js"

import "./RingScreen.vue?vue&type=style&index=0&id=6c6aaade&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c6aaade"]])

export default __exports__